import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Formik, getIn } from 'formik';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useParams } from 'react-router-dom';
import { useConfirmEditTransportCompanyModal } from '../../../components/modals/ConfirmEditTransportCompanyModal/useConfirmEditTransportCompanyModal'
import { CreateTC, Button, DisableOrganizationModal, SwitchAdminForm, InviteUserForm } from '../../../components';
import { createTransportCompanySchema, LodashHelper, GoogleAddressHelper } from '../../../utils';
import { TC_OPERATIONAL_HOURS, FLEET_OPTIONS } from '../../../constants/constants'
import {
  fetchTransportOrganization,
  disableTO,
  suspendTO,
  updateTO,
  switchTCAdmin,
  inviteNewUserForTc,
} from '../../../store/transport_organizations';
import { fetchStatesList } from '../../../store/common';
import { getAdditionalRideOptions } from '../../../store/preferences';
import { fetchUsersByOrganization } from '../../../store/users';
import { BackIcon } from '../../../assets';
import { getSortedEmployees } from '../../../store/selectors/users';
import {
  handleAddCounties,
  handleCountiesSelect,
  handleDelete,
  handleStateSelect,
  getRegionFormFields,
  formatTransportCompanySubmit,
} from '../../../utils/countiesHelper';

import styles from './index.module.css';
import { Navigation } from '../../../utils/navigation';

const Update_Transport_Company = ({
  currentTransportOrganization,
  history,
  fetchTransportOrganization,
  disableTO,
  suspendTO,
  updateTO,
  switchTCAdmin,
  getAdditionalRideOptions,
  rideOptions,
  inviteNewUserForTc,
  fetchUsersByOrganization,
  users,
  fetchStatesList,
  counties,
  cities,
  states,
}) => {
  const [inviteUserModalVisible, setInviteUserModalVisible] = useState(false);
  const [disableOrganizationModalVisible, setDisableOrganizationModalVisible] = useState(false);
  const [suspendOrganizationModalVisible, setSuspendOrganizationModalVisible] = useState(false);
  const [removeSuspensionModalVisible, setRemoveSuspensionModalVisible] = useState(false);
  const [updateAdminModalVisible, setUpdateAdminModalVisible] = useState(false);
  const [finalFormValues, setFinalFormValues] = useState({});
  const formRef = useRef();
const navigate =Navigation();
  useEffect(() =>{ fetchStatesList(); return;}, [fetchStatesList]);

  useEffect(() => {getAdditionalRideOptions(); return;}, [getAdditionalRideOptions]);

  const { id } = useParams();

  useEffect(() => {formRef?.current?.validateForm(); return;}, []);

  useEffect(() => {fetchTransportOrganization(id); return;}, [fetchTransportOrganization, id]);

  const handleBack = useCallback(() => navigate.back(), [navigate]);

  const handleSelectAddress = ({ value, values, setValues }) => {
    setValues({ ...values, location: GoogleAddressHelper.transformFields(value) });
  };

  const handleChangeAddress = ({ value, values, setValues }) => {
    setValues({
      ...values,
      location: {
        formattedAddress: value,
      },
    });
  };

  const onCancelInviteUser = (resetForm) => () => {
    setInviteUserModalVisible(false);
    resetForm({ email: '' });
  };

  const onCancelSwitchAdmin = (resetForm) => () => {
    setUpdateAdminModalVisible(false);
    resetForm();
  };

  const onCancelDisableModal = () => setDisableOrganizationModalVisible(false);

  const onCancelSuspendModal = () => setSuspendOrganizationModalVisible(false);

  const onCancelRemoveSuspensionModal = () => setRemoveSuspensionModalVisible(false);

  const handleInviteUser = () => setInviteUserModalVisible(true);

  const handleDisableOrganization = () => setDisableOrganizationModalVisible(true);

  const handleSuspendOrganization = () => setSuspendOrganizationModalVisible(true);

  const handleRemoveSuspension = () => setRemoveSuspensionModalVisible(true);

  const onConfirmDisable = () => disableTO({ id, disabled: true,Navigation:navigate });

  const onConfirmSuspend = () => suspendTO({ id, Navigation: navigate });

  const onConfirmRemoveSuspension = () => updateTO({
    values: {
      suspendedAt: null,
      rideOptions: (currentTransportOrganization?.rideOptions || []).map((option) => option.id || option),
    },
    id,
    Navigation: navigate,
  });

  const onConfirmSwitchAdmin = ({ organizationId, userId }) =>
    switchTCAdmin({ organizationId, userId, closeModal: () => setUpdateAdminModalVisible(false) });

  const onConfirmInviteUser = ({ organizationId, values }) =>
    inviteNewUserForTc({ organizationId, values, closeModal: () => setInviteUserModalVisible(false) });

  const handleChangeAdmin = () => {
    fetchUsersByOrganization({ id });
    setUpdateAdminModalVisible(true);
  };

  const { confirmModalVisible, setConfirmModalVisible, Modal } =
    useConfirmEditTransportCompanyModal({
      onConfirm: (reasonForUpdate) =>
        updateTO({
          values: LodashHelper.trimValues(formatTransportCompanySubmit({
            ...finalFormValues,
            ...reasonForUpdate,
          })),
          id ,Navigation:navigate,
          onSuccesCallback: () => setConfirmModalVisible(false),
        }),
    });

    const handleSubmitTC = (values) => {
      setFinalFormValues(values); 
      const fleetSizeUpdated = !LodashHelper.isEqual(
        getIn(values, "fleetSizes"),
        currentTransportOrganization?.fleetSizes
      );
      if (fleetSizeUpdated) {
        setConfirmModalVisible(true);
      } else {
        updateTO({ values: LodashHelper.trimValues(formatTransportCompanySubmit(values)), id ,Navigation:navigate});
      }
    };
 
  return (
    <div className={styles.pageContent}>
      <div className={styles.header}>
        <div className={styles.backBtn} onClick={handleBack}>
          <BackIcon width='26px' height='26px' fill='#E1F4D3' />
        </div>
        <h1 className={styles.pageTitle}>Company Details</h1>
      </div>
      <div>
        <h2>Information on the Transportation Company</h2>
        <Formik
          enableReinitialize
          validationSchema={createTransportCompanySchema}
          validateOnMount
          validateOnChange={false}
          initialValues={
            currentTransportOrganization
              ? {
                ...currentTransportOrganization,
                fleetSizes: Array.isArray(currentTransportOrganization.fleetSizes)
                  ? currentTransportOrganization.fleetSizes
                  : FLEET_OPTIONS,
                hourOfOperations: currentTransportOrganization?.hourOfOperations || TC_OPERATIONAL_HOURS,
                driverSchedulingBuffer: currentTransportOrganization?.driverSchedulingBuffer ?? 30,
                operationalCity: currentTransportOrganization?.operationalCity || [],
                ...getRegionFormFields(
                  currentTransportOrganization?.regionsOfOperation,
                  currentTransportOrganization?.operationalCity,
                ),
              }
              : {
                  name: '',
                  regionsOfOperation: [],
                  operationalCity: [],
                  location: {
                    formattedAddress: '',
                  },
                  admin: {
                    email: '',
                    firstName: '',
                    lastName: '',
                  },
                  state: '',
                  counties: [],
                  cities: [],
                  vehicleTypes: [],
                  fleetSizes:FLEET_OPTIONS,
                  hourOfOperations:TC_OPERATIONAL_HOURS, 
                  rideOptions: [],
                  scheduledRidesReminderHour: null,
                  scheduledRidesReminderDay: '',
                  preferredTimezone: '',
                  driverSchedulingBuffer: 30,
                }
          }
          onSubmit={({ admin, counties, state, cities, ...values }) => {
            handleSubmitTC(formatTransportCompanySubmit(values));
          }}>
          {({ values, ...rest }) => {
            return (
              <form className={styles.form} onSubmit={rest.handleSubmit}>
                <CreateTC
                  values={values}
                  hideUberVehicleOption
                  states={states}
                  counties={counties}
                  cities={cities}
                  switchAdmin
                  handleSelectAddress={handleSelectAddress}
                  handleChangeAddress={handleChangeAddress}
                  handleInviteUser={handleInviteUser}
                  handleChangeAdmin={handleChangeAdmin}
                  personalInfoFieldsDisabled
                  handleStateSelect={handleStateSelect}
                  handleCountiesSelect={handleCountiesSelect(counties)}
                  handleAddCounties={handleAddCounties({ values, setValues: rest.setValues })}
                  handleDelete={handleDelete}
                  rideOptions={rideOptions}
                  {...rest}
                />
                <div className={styles.btnPanel}>
                  <div className={styles.btnControl}>
                    <Button myClassName={styles.navigationBtn} onClick={handleDisableOrganization}>
                      Deactivate Company
                    </Button>
                  </div>
                  <div className={styles.btnControl}>
                    <Button
                      myClassName={styles.navigationBtn}
                      type="button"
                      onClick={currentTransportOrganization?.suspendedAt ? handleRemoveSuspension : handleSuspendOrganization}>
                      {currentTransportOrganization?.suspendedAt ? 'Remove Suspension' : 'Suspend Access'}
                    </Button>
                  </div>
                  <div className={styles.btnControl}>
                    <Button disabled={!rest.isValid} type='submit'>
                      Save Changes
                    </Button>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </div>
      <DisableOrganizationModal
        name={currentTransportOrganization?.name}
        visible={disableOrganizationModalVisible}
        onCancel={onCancelDisableModal}
        onConfirm={onConfirmDisable}
      />
      <DisableOrganizationModal
        name={currentTransportOrganization?.name}
        visible={suspendOrganizationModalVisible}
        onCancel={onCancelSuspendModal}
        onConfirm={onConfirmSuspend}
        title="Suspend Access"
        confirmText="Confirm"
        description="Suspending access will prevent this organization from accepting new rides; It may complete rides that were previously accepted and assigned to a driver."
      />
      <DisableOrganizationModal
        visible={removeSuspensionModalVisible}
        onCancel={onCancelRemoveSuspensionModal}
        onConfirm={onConfirmRemoveSuspension}
        title="Remove Suspension"
        confirmText="Confirm"
        description="Confirming will restore this organization’s access to MedHaul and allow it to accept new rides."
      />

      <SwitchAdminForm
        users={users}
        id={id}
        formRef={formRef}
        updateAdminModalVisible={updateAdminModalVisible}
        onCancel={onCancelSwitchAdmin}
        onConfirmSwitchAdmin={onConfirmSwitchAdmin}
      />

      <InviteUserForm
        id={id}
        formRef={formRef}
        inviteUserModalVisible={inviteUserModalVisible}
        onCancelInviteUser={onCancelInviteUser}
        onConfirmInviteUser={onConfirmInviteUser}
      />
       {confirmModalVisible && Modal}
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentTransportOrganization: state.transportOrganizations.currentTransportOrganization,
  rideOptions: state.preferences.rideOptions?.filter((option) => !option.disabled),
  users: getSortedEmployees(state, styles),
  counties: state.common.counties,
  cities: state.common.cities,
  states: state.common.states,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchTransportOrganization,
      disableTO,
      suspendTO,
      updateTO,
      switchTCAdmin,
      getAdditionalRideOptions,
      inviteNewUserForTc,
      fetchUsersByOrganization,
      fetchStatesList,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Update_Transport_Company);
